export default function Footer() {
  return (
    <footer class="site-footer">
      <div class="wrap footer-inner">
        <span>© 2026 Daftari. All rights reserved.</span>
        <div class="footer-links">
          <a href="#" rel="noopener noreferrer">Privacy</a>
          <a href="#" rel="noopener noreferrer">Terms</a>
          <a href="mailto:hello@example.com">Contact us</a>
        </div>
      </div>
    </footer>
  );
}